module.exports = __webpack_public_path__ + "img/infoguidance_mov_03.2a116157.jpg";